/**
 * Pure helpers for the Dyrejournal «Ikke møtt» overview page.
 * Dates are handled as local 'YYYY-MM-DD' strings to match <input type='date'>.
 */
const pad = n => String(n).padStart(2, '0');

export function isoDay(date) {
    const d = new Date(date);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function defaultNoShowRange(now = new Date()) {
    const to = new Date(now);
    const from = new Date(now);
    from.setMonth(from.getMonth() - 12);
    return { fromDate: isoDay(from), toDate: isoDay(to) };
}

// The backend treats `end` as exclusive, so "to and including this day"
// means the start of the following day.
export function toExclusiveEnd(isoDate) {
    const [y, m, d] = String(isoDate).split('-').map(n => parseInt(n, 10));
    return isoDay(new Date(y, m - 1, d + 1));
}

export function filterRowsByOwner(rows, ownerId) {
    const list = rows || [];
    if (!ownerId) {
        return list;
    }
    return list.filter(row => (row.animals || []).some(a => a.owner && a.owner.id === ownerId));
}

export function rowOwner(row) {
    const animal = (row?.animals || []).find(a => a.owner && a.owner.id > 0);
    return animal ? animal.owner : null;
}

export function ownerDisplayName(owner) {
    if (!owner) {
        return '';
    }
    return `${owner.firstname || ''} ${owner.lastname || ''}`.trim();
}
